
export function getQuery (queryParam,callback) {
	const s = location.search
	const regExp = new RegExp( queryParam + '=[^&\\s]+')
	if(s.indexOf(queryParam)>0) {
		// location.search.match(/(?<=(teaId=))\d+/)
		let t = s.match(regExp)
		if(t.length){
			t= t[0].replace(queryParam+'=','').replace(/,/g,'')
		}
		if(callback){callback(t)}
		return t
	}
	return ''
}



// WEBPACK FOOTER //
// ./src/utils/getQuery.js